import { render, staticRenderFns } from "./AppArticle.vue?vue&type=template&id=3af1d802&scoped=true&"
import script from "./AppArticle.vue?vue&type=script&lang=js&"
export * from "./AppArticle.vue?vue&type=script&lang=js&"
import style0 from "./AppArticle.vue?vue&type=style&index=0&id=3af1d802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af1d802",
  null
  
)

export default component.exports